import anime from 'animejs';
import cx from 'classnames';
import { getOuterWidth } from 'platform-components/utils';
import PropTypes from 'prop-types';
import React from 'react';

import './journal-carousel.scss';

class Carousel extends React.Component {
    static propTypes = {
        children: PropTypes.arrayOf(PropTypes.node),
        courseId: PropTypes.number,
        duration: PropTypes.number,
        easing: PropTypes.string,
        mix: PropTypes.string,
        onScroll: PropTypes.func,
        step: PropTypes.number,
    };

    static defaultProps = {
        duration: 300,
        easing: '',
        nativeScroll: false,
        step: 1,
    };

    UNSAFE_componentWillMount() {
        this.position = 0;
    }

    componentDidMount() {
        this.calculateScrollLength(this.props);

        // Проскроллить журнал к последнему занятию
        this.position = this.scrollLength - 1;
        this.scroll('right');
    }

    componentDidUpdate(prevProps) {
        if (prevProps.children.length !== this.props.children.length) {
            this.calculateScrollLength(this.props);
        }

        if (prevProps.courseId !== this.props.courseId) {
            this.resetPosition();
        }
    }

    resetPosition = () => {
        if (this.props.onScroll) {
            this.props.onScroll({
                length: this.scrollLength,
                position: 0,
            });
        }

        this.position = 0;
    };

    onCarouselItemsRef = React.createRef();

    onCarouselItemRef = (ref) => {
        this._itemWidth = ref ? getOuterWidth(ref, true) : 0;
    };

    calculateScrollLength = (props) => {
        const { current: items } = this.onCarouselItemsRef;
        const carouselWidth = getOuterWidth(items);
        const itemsLength = this._itemWidth * React.Children.count(props.children);

        if (itemsLength > carouselWidth) {
            this.scrollLength = itemsLength;
            if (this.scrollLength > carouselWidth) {
                this.scrollLength -= carouselWidth;
            }
        } else {
            this.scrollLength = null;
        }
    };

    scroll = (direction) => {
        const { current: items } = this.onCarouselItemsRef;

        if (!this.scrollLength) {
            return;
        }

        const step = this._itemWidth * this.props.step;
        let nextPosition = this.position;

        switch (direction) {
            case 'left':
                nextPosition -= step;
                break;
            case 'right':
                nextPosition += step;
                break;
            default:
                break;
        }
        if (nextPosition < 0) {
            nextPosition = 0;
        } else if (nextPosition > this.scrollLength) {
            nextPosition = this.scrollLength;
        }
        if (nextPosition === this.position) {
            return;
        }
        if (this.props.onScroll) {
            this.props.onScroll({
                length: this.scrollLength,
                position: nextPosition,
            });
        }

        const timeline = anime.timeline({
            easing: this.props.easing,
            duration: this.props.duration,
        });
        timeline.add({
            targets: items,
            scrollLeft: nextPosition,
        });
        this.position = nextPosition;
    };

    render() {
        const { mix, children, courseId } = this.props;

        return (
            <div className={cx('journal-carousel', mix)}>
                <div className="journal-carousel__content">
                    <div className="journal-carousel__items" ref={this.onCarouselItemsRef}>
                        {React.Children.map(children, (child, i) =>
                            React.cloneElement(child, {
                                className: cx(child.props.className, 'journal-carousel__item'),
                                key: `${courseId}-${i}`,
                                ref: this.onCarouselItemRef,
                            })
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default Carousel;
